// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";
import { Tag } from "antd";
import { useStore } from "effector-react";
import { ProfilesStore } from "../../../../state/profiles/ProfilesStore";

type UserProfileProps = {
  profile?: string;
};

const UserProfileTag: React.FunctionComponent<UserProfileProps> = (
  props: UserProfileProps
) => {
  const profileList = useStore(ProfilesStore);

  const profile = props.profile ? profileList[props.profile] : null;

  return profile ? <Tag color={profile.color}>{profile.label}</Tag> : null;
};

export default UserProfileTag;
